import axios from 'axios';
import moment from 'moment';
import { toast } from "react-toastify";
import { handleLogOut } from "../utils/ClearCache";
import { jwtDecode } from "jwt-decode";


const baseURL = process.env.REACT_APP_API_URL + "v1/api/";
const axiosInstance = axios.create({ baseURL });

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (newAccessToken) => {
  refreshSubscribers.map((callback) => callback(newAccessToken));
};

const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

const refreshAccessToken = async (refreshToken) => {
  try {
    const keycloakConfig = {
      url: process.env.REACT_APP_KEYCLOAK_URL,
      realm: process.env.REACT_APP_KEYCLOAK_REALM,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
    };
    
    const tokenEndpoint = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/token`;
    const response = await axios.post(tokenEndpoint, new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: keycloakConfig.clientId,
      refresh_token: refreshToken,
    }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

    console.log('Refreshed access token response:', response.data);
    return response.data;
  } catch (error) {
    const errMsg = error?.response?.status;
    if (errMsg === 400) {
      console.error("Refresh token expired, redirecting to login");
      handleLogOut();
    }
    console.error("Failed to refresh token", error);
    return null;
  }
};

axiosInstance.interceptors.request.use(
  async(config) => {
    console.log("Intercepting request");
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    const accessTokenExpiry = localStorage.getItem('accessTokenExpiry');

    if (!token || !refreshToken || !accessTokenExpiry) {
      console.error("Token or expiry data is missing, aborting request");
      return config
    }

    try {
      if (moment().isAfter(moment(accessTokenExpiry).subtract(1, 'minute'))) {
        if (!isRefreshing) {
          isRefreshing = true;
          console.log("Access token close to expiry, refreshing");

          const response = await refreshAccessToken(refreshToken);
          
          if (response) {
            const { access_token: newAccessToken, expires_in: accessTokenExpiryInSeconds, refresh_token: newRefreshToken } = response;

            localStorage.setItem('token', `Bearer ${newAccessToken}`);
            localStorage.setItem('accessTokenExpiry', moment().add(accessTokenExpiryInSeconds, 'seconds').format('YYYY-MM-DD HH:mm:ss'));
            localStorage.setItem('refreshToken', newRefreshToken);
            const decodedToken = jwtDecode(token);
            localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
  
            config.headers.Authorization = `Bearer ${newAccessToken}`;
            isRefreshing = false;
            onRefreshed(newAccessToken);
            refreshSubscribers = [];
            console.log("Access token refreshed successfully");
          }
        } else {
          const retryOriginalRequest = new Promise((resolve) => {
            addRefreshSubscriber((newAccessToken) => {
              config.headers.Authorization = `Bearer ${newAccessToken}`;
              resolve(config);
            });
          });
          return retryOriginalRequest;
        }
      } else {
        console.log("Using existing access token");
        config.headers.Authorization = token;

      }
    } catch (err) {
      console.error("Error during request interceptor", err);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    
    const userInfoHeader = response?.headers['x-user-info'];
    if(userInfoHeader)
      {
        console.log('user info exist');
    const userInfo = JSON.parse(userInfoHeader);
    const userRoles = userInfo.roles;

    const editAccess = localStorage.getItem('editAccess');
   // console.log('editAccess',!editAccess && userInfo !== editAccess);
    if(!editAccess && userInfo !== editAccess) {
    //  console.log('setting editAccess',editAccess);
    localStorage.setItem('editAccess', userInfo.roles);
    }
   // console.log("responsessss",userRoles);
      }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    
    // if (error?.message === 'Network Error') {
    //   toast.error("User not authorized");
    // }
    if (status === 401 || status === 403 ) {
      console.error(`Request failed with status ${status}`);
      //handleLogOut();
    }
  }
);

export default axiosInstance;
